<template>
	<v-dialog
		v-model="showDialog"
		max-width="1200px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		@click:outside="closeDialog"
	>
		<v-card tile height="90vh" class="overflow-hidden">
			<v-app-bar
				dense
				dark
				flat
				color="primary"
				elevate-on-scroll
				scroll-target="#scroll-area"
				extension-height="40px"
			>
				<v-app-bar-title class="color-white">ゴム生地詳細情報</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
				<template v-slot:extension>
					<v-tabs
						v-model="tab"
						height="40px"
						slider-color="primary"
						background-color="#f0f0f0"
						color="black"
						@change="selectTab"
					>
						<v-tab v-for="(item, i) in tabs" :key="i">
							{{ item.name }}
						</v-tab>
					</v-tabs>
				</template>
			</v-app-bar>
			<v-sheet elevation="0" id="scroll-area" class="overflow-y-auto" height="calc(90vh - 88px)">
				<!-- Todo スマホサイズ時に左に空白ができる -->
				<v-tabs-items v-model="tab" class="pa-2" @change="selectTab">
					<RubberInfoTab :rubber="rubber" :authority="authority" />
					<RubberCustomerCompanyShowTab
						:rubber="rubber"
						:isFetched="isFetched('ゴム生地使用企業一覧')"
					/>
					<AnticipatedOrderedProductTab
						:rubber="rubber"
						:isFetched="isFetched('使用見込み製品(受注時)')"
					/>
					<AnticipatedMatterProductTab
						:rubber="rubber"
						:isFetched="isFetched('使用見込み製品(未受注時)')"
					/>
				</v-tabs-items>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import RubberCustomerCompanyShowTab from "../tabs/RubberCustomerCompanyShowTab.vue"
import RubberInfoTab from "../tabs/RubberInfoTab.vue"
import AnticipatedOrderedProductTab from "../tabs/AnticipatedOrderedProductTab.vue"
import AnticipatedMatterProductTab from "../tabs/AnticipatedMatterProductTab.vue"

export default {
	// TODO propsでidを受け取って、ダイアログ内でfetchするパターンも作る
	// このダイアログをどこからでも呼び出せるようにするため
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		authority: {
			type: Boolean,
			required: false,
			default: false,
		},
		rubber: {
			type: Object,
			required: false,
		},
	},
	components: {
		RubberInfoTab,
		RubberCustomerCompanyShowTab,
		AnticipatedOrderedProductTab,
		AnticipatedMatterProductTab,
	},
	data() {
		return {
			tab: 0,
			tabs: tabs(),
		}
	},
	mounted() {},
	methods: {
		selectTab() {
			this.tabs[this.tab].isFetched = true
		},
		closeDialog() {
			this.reset()
			this.showDialog = false
		},
		reset() {
			Object.assign(this.$data, this.$options.data())
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
		isFetched() {
			return (name) => {
				const tab = this.tabs.find((t) => t.name == name)
				return tab != null ? tab.isFetched : false
			}
		},
	},
	watch: {},
}

function tabs() {
	return [
		{ name: "ゴム生地情報", isFetched: false },
		{ name: "ゴム生地使用企業一覧", isFetched: false },
		{ name: "使用見込み製品(受注時)", isFetched: false },
		{ name: "使用見込み製品(未受注時)", isFetched: false },
	]
}
</script>
